import { useEffect, useRef, useState } from "react";
import { CalendarDays } from "lucide-react";
import { Shell, PageHead, Kpi, money } from "./dc";
import { KPIS, PERIODS, open } from "./leadsexec/data";
import { FunnelWaterfall } from "./leadsexec/FunnelWaterfall";
import { LeadsTrend } from "./leadsexec/LeadsTrend";
import { RepTable, LostReasons } from "./leadsexec/RepTable";
import { ServicesRequested, LeadDrill } from "./leadsexec/ServicesDrill";

const DatePicker = ({ p, setP }) => (
  <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
    <div className="tabs" data-testid="lx-period">
      {PERIODS.map((x) => <button key={x} className={`tab ${p === x ? "active" : ""}`} onClick={() => setP(x)} data-testid={`lx-period-${x.replace(/\W/g, "").toLowerCase()}`}>{x}</button>)}
    </div>
    <span className="chip" data-testid="lx-compare"><CalendarDays size={12} style={{ marginRight: 4 }} />vs previous period</span>
  </div>
);

const Clickable = ({ onClick, children }) => <div onClick={onClick} style={{ cursor: "pointer" }}>{children}</div>;

export default function LeadsExecMockup() {
  const [p, setP] = useState("MTD");
  const [pick, setPick] = useState(null);
  const drillRef = useRef(null);
  const k = KPIS;
  const show = (stage, n) => setPick({ stage, n });
  useEffect(() => { if (pick) drillRef.current?.scrollIntoView({ behavior: "smooth", block: "start" }); }, [pick]);
  return (
    <Shell title="Leads" testid="leads-exec-mockup">
      <PageHead title="Leads · Executive view" sub="Pipeline, conversion and follow-up speed at a glance. Click any number or bar to see the leads behind it. Sample data only." right={<DatePicker p={p} setP={setP} />} />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 12, marginBottom: 24 }}>
        <Kpi label="Conversion" value={`${k.conversion.toFixed(1)}%`} trend="+3.2 pts vs prev" status="pos" testid="lx-kpi-conversion" />
        <Kpi label="Avg deal size · 90d" value={money(k.dealSize)} trend={`+${money(k.dealSize - k.prevDealSize)} vs prev`} status="pos" testid="lx-kpi-deal" />
        <Clickable onClick={() => show("Won", 31)}><Kpi label="Won revenue · 90d" value={money(k.revenueWon)} sub="from 31 won leads" testid="lx-kpi-revenue" /></Clickable>
        <Clickable onClick={() => show("Still open", open)}><Kpi label="Open leads" value={open} sub={`avg age ${k.avgAge}d · tap to see them`} testid="lx-kpi-open" /></Clickable>
        <Kpi label="Speed to lead" value={`${k.speedToLead}m`} trend="−14m vs prev" status="pos" sub="median first reply" testid="lx-kpi-speed" />
        <Kpi label="Follow-up turnaround" value={`${k.turnaround}h`} sub={`${k.touchesToWin} touches to win`} testid="lx-kpi-turnaround" />
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
        <FunnelWaterfall onPick={show} />
        <LeadsTrend period={p} />
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: 24, alignItems: "start" }}>
          <ServicesRequested onPick={show} />
          <LostReasons />
        </div>
        <RepTable />
        <div ref={drillRef}><LeadDrill pick={pick} onClose={() => setPick(null)} /></div>
      </div>
    </Shell>
  );
}
